// Abre o popup "Embedded Signup" da Meta pra o admin conectar o WhatsApp do
// estabelecimento sem precisar saber o que é Phone Number ID / Access Token.
//
// O popup devolve duas coisas, por caminhos diferentes e sem ordem garantida:
//   - o `code` (no callback do FB.login), que o backend troca pelo token
//   - waba_id + phone_number_id (por window.postMessage vindo de facebook.com)
// Esta função espera as duas e resolve com { code, waba_id, phone_number_id }.

const APP_ID = process.env.REACT_APP_META_APP_ID;
const CONFIG_ID = process.env.REACT_APP_META_WA_CONFIG_ID;
const GRAPH_VERSION = process.env.REACT_APP_META_GRAPH_VERSION || "v20.0";

let sdkPromise = null;

function carregarSdkFacebook() {
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }

    window.fbAsyncInit = () => {
      window.FB.init({ appId: APP_ID, autoLogAppEvents: true, xfbml: false, version: GRAPH_VERSION });
      resolve(window.FB);
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.onerror = () => {
      sdkPromise = null;
      reject(new Error("Não foi possível carregar o login do Facebook. Verifique se algum bloqueador está ativo."));
    };
    document.body.appendChild(script);
  });

  return sdkPromise;
}

export function embeddedSignupConfigurado() {
  return Boolean(APP_ID && CONFIG_ID);
}

export async function abrirEmbeddedSignup() {
  if (!embeddedSignupConfigurado()) {
    throw new Error("Conexão do WhatsApp não configurada (REACT_APP_META_APP_ID / REACT_APP_META_WA_CONFIG_ID).");
  }

  const FB = await carregarSdkFacebook();

  return new Promise((resolve, reject) => {
    let code = null;
    let sessao = null;
    let finalizado = false;

    const terminar = (erro) => {
      if (finalizado) return;
      if (!erro && !(code && sessao)) return;
      finalizado = true;
      window.removeEventListener("message", onMessage);
      if (erro) reject(erro);
      else resolve({ code, waba_id: sessao.waba_id, phone_number_id: sessao.phone_number_id });
    };

    function onMessage(event) {
      if (!/(^|\.)facebook\.com$/.test(new URL(event.origin).hostname)) return;

      let dados;
      try {
        dados = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch {
        return;
      }
      if (dados?.type !== "WA_EMBEDDED_SIGNUP") return;

      if (dados.event === "FINISH" || dados.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING") {
        sessao = dados.data;
        terminar();
      } else if (dados.event === "CANCEL") {
        terminar(new Error("Cadastro do WhatsApp cancelado."));
      } else if (dados.event === "ERROR") {
        terminar(new Error(dados.data?.error_message || "A Meta retornou um erro no cadastro do WhatsApp."));
      }
    }

    window.addEventListener("message", onMessage);

    // O SDK não aceita função async como callback do FB.login.
    FB.login(
      (response) => {
        if (response.authResponse?.code) {
          code = response.authResponse.code;
          terminar();
          // Caso raro: popup fechado com code mas sem o evento FINISH.
          setTimeout(() => terminar(sessao ? null : new Error("A Meta não devolveu o número cadastrado. Tente de novo.")), 10000);
        } else {
          terminar(new Error("Cadastro do WhatsApp cancelado."));
        }
      },
      {
        config_id: CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
        extras: { setup: {}, featureType: "", sessionInfoVersion: "3" }
      }
    );
  });
}
